import { HowlerSoundFile } from 'source/app/services/Sound/HowlerSoundFile';

class PlayingSoundFiles {
	private playingSoundFiles: HowlerSoundFile[] = [];

	Add(soundFile: HowlerSoundFile) {
		this.playingSoundFiles.push(soundFile);
	}

	Remove(soundFile: HowlerSoundFile) {
		var filteredFiles = this.playingSoundFiles.filter((psf) => psf.filename !== soundFile.filename);
		this.playingSoundFiles = filteredFiles;
	}

	Contains(toFind: HowlerSoundFile) {
		return this.playingSoundFiles.map((psf) => psf.filename).includes(toFind.filename);
	}

	Find (toFind: HowlerSoundFile) {
		return this.playingSoundFiles.find((psf) => psf.filename === toFind.filename);
	}
}

// Singleton
export const playingSoundFiles = new PlayingSoundFiles();
